import React, { ReactNode } from 'react';
import Typography from '@mui/material/Typography';
import RichText from 'components/RichText/RichText';
import { Div } from 'components/Elements/Div/Div';
import { OverviewDetailInterface } from 'components/Overview/overview.types';

interface RowDetailProps extends Omit<OverviewDetailInterface, 'value'> {
  value?: ReactNode;
  children?: ReactNode;
}

type Props = RowDetailProps;

const RowDetail = ({
  marginRight,
  minWidth,
  richText,
  title,
  value,
  width,
  titleProps,
  children,
}: Props) => {
  return (
    <Div
      margin={`1rem ${marginRight ?? '0'} 0 0`}
      display='flex'
      flexDirection='column'
      width={width ?? 'calc(100% - 9.6rem)'}
      minWidth={minWidth ?? ''}
      color='black'
    >
      <Typography
        variant='subtitle1'
        component='div'
        sx={{ fontWeight: 500, fontSize: '1.125rem', color: 'black' }}
        {...titleProps}
      >
        {title}
      </Typography>
      {!value && value !== 0 ? (
        !children ? (
          'N/A'
        ) : null
      ) : richText ? (
        <RichText value={`${value}`} />
      ) : (
        value
      )}
      {children}
    </Div>
  );
};

export default RowDetail;
